export const state = () => ({
  modalVisible: false,
  mediumId: null,
  fallbackSrc: null,
  resource: null
})

export const mutations = {
  setModalVisible(state, modalVisible) {
    state.modalVisible = modalVisible
  },

  setMediumId(state, mediumId) {
    state.mediumId = mediumId
  },

  setFallbackSrc(state, fallbackSrc) {
    state.fallbackSrc = fallbackSrc
  },

  setResource(state, resource) {
    state.resource = resource
  }
}

export const actions = {
  openZoom({ commit }, { mediumId, fallbackSrc, resource }) {
    commit('setModalVisible', true)
    commit('setMediumId', mediumId)
    commit('setFallbackSrc', fallbackSrc)
    commit('setResource', resource)
  },

  closeZoom({ commit }) {
    commit('setModalVisible', false)
    commit('setMediumId', null)
    commit('setFallbackSrc', null)
    commit('setResource', null)
  }
}

export const getters = {
  isVisible(state) { return state.modalVisible },

  mediumId(state) { return state.mediumId },

  fallbackSrc(state) { return state.fallbackSrc },

  mediumResource(state) { return state.resource }
}
